module.exports = {
      id: "3065d53348a6a8168620c2fc26a6c456equipment-kitchen-hood.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#3065d53348a6a8168620c2fc26a6c456equipment-kitchen-hood.svg",
      toString: function () {
        return this.url;
      }
    }